import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { TeamSchema } from './teams';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

const ProjectNameSchema = z.string().min(1).max(255);

/**
 * A project is a construct to represent an instance or evolving task that requires both sets of data and linked insights, analysis or notes
 */
export const ProjectSchema = z.object({
  projectId: PrimaryKeySchema,
  teamId: TeamSchema.shape.teamId,
  name: ProjectNameSchema,
  createdAt: z.coerce.date(),
});

export type Project = z.infer<typeof ProjectSchema>;

export const ProjectsSchema = z.array(ProjectSchema);

export type Projects = z.infer<typeof ProjectsSchema>;

export const ProjectsQuerySchema = z
  .object({
    projectIds: commaDelimitedList(
      ProjectSchema.shape.projectId.array(),
    ).optional(),
    teamIds: commaDelimitedList(TeamSchema.shape.teamId.array()).optional(),
  })
  .merge(createOffsetPaginationRequestQuerySchema(z.enum(['createdAt'])));

export const DeleteProjectsQuerySchema = ProjectsQuerySchema.pick({
  projectIds: true,
}).required();

export type DeleteProjectsQuery = z.infer<typeof DeleteProjectsQuerySchema>;

export type ProjectsQuery = z.infer<typeof ProjectsQuerySchema>;

export const CreateProjectRequestSchema = z.object({
  teamId: TeamSchema.shape.teamId,
  name: ProjectNameSchema,
});

export type CreateProjectRequest = z.infer<typeof CreateProjectRequestSchema>;

export const UpdateProjectRequestSchema = CreateProjectRequestSchema.pick({
  name: true,
}).partial();

export type UpdateProjectRequest = z.infer<typeof UpdateProjectRequestSchema>;
